import moment from "moment";

export const STORAGE_FORMAT = "YYYY-MM-DD";
export const DISPLAY_FORMAT = "DD/MM/YYYY";
export const PLACEHOLDER_TEMPLATE = "DD/MM/YYYY";
export const POPUP_OFFSET_TOP = 20;
export const POPUP_OFFSET_LEFT = -12;

export function parseStoredDate(value: string | undefined) {
  if (!value) return undefined;
  const date = moment(value, STORAGE_FORMAT, true);
  return date.isValid() ? date.toDate() : undefined;
}

export function applyDateMask(digits: string) {
  const d = digits.slice(0, 8);
  let result = "";
  for (let i = 0; i < d.length; i += 1) {
    if (i === 2 || i === 4) result += "/";
    result += d[i];
  }
  return result;
}

export function getGhostText(currentInput: string) {
  return {
    invisible: currentInput,
    visible: PLACEHOLDER_TEMPLATE.slice(currentInput.length),
  };
}

export function parseDateFromDigits(digits: string) {
  if (digits.length < 8) return null;

  const day = parseInt(digits.slice(0, 2), 10);
  const month = parseInt(digits.slice(2, 4), 10) - 1;
  const year = parseInt(digits.slice(4, 8), 10);
  const date = new Date(year, month, day);

  return moment(date).isValid() && date.getDate() === day && date.getMonth() === month ? date : null;
}

export function formatStoredToInput(value: string | undefined) {
  if (!value) return { inputValue: "", rawDigits: "" };

  const date = moment(value, STORAGE_FORMAT, true);
  if (date.isValid()) {
    const inputValue = date.format(DISPLAY_FORMAT);
    return { inputValue, rawDigits: inputValue.replace(/\D/g, "") };
  }

  return { inputValue: value, rawDigits: value.replace(/\D/g, "") };
}
